import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import Constants from "../../../Constants";
import $, { event } from "jquery";
import { getAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { handleError } from "../../../services/authApiRoutes/APImethods";
export default function ProjectSettingPreferredVendors() {
  const scrollRef = useRef(null);
  const backRef = useRef();
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const [pending, setPending] = useState(true);
  const [preferedVendorAllGroup,setPreferedVendorAllGroup] = useState([])
  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
      .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING });
  };
  const columns = [
    {
      id: "userGroup.name",
      name: "Department",
      maxWidth: "350px",
      selector: (row) => row.userGroup.name,
      sortable: true, 
      cell: (row) => row.userGroup.name,
    },
    {
      id: "prefferedVendor.name",
      name: "Preferred Vendor",
      maxWidth: "350px",
      selector: (row) => row.vendor.name,
      sortable: true,
      cell: (row) => row.vendor.name,
    },
  ];
  const noDataFoundComponent = () => {
    return (
      <div className="no-data-display align-center">
        <i className="nodata-icon"></i>
        <p>{Constants.NO_DATA_FOUND}</p>
      </div>
    );
  };

  useEffect(()=>{
    getAxiosResponse(APIUrls.GET_PREFERRED_VENDOR_ALL_GROUP)
      .then((res) => {
        if (res.data !== "") {
          const processedData = preprocessData(res.data.data);
          setPreferedVendorAllGroup(processedData);

          setPending(false);
        }
      }).catch((err) => {
        handleError(err);
      });
  },[])


  const preprocessData = (data) => {
    const departmentMap = new Map();

    data.forEach((row) => {
      const departmentName = row.userGroup.name;
      const vendorName = row.vendor.name;

      if (departmentMap.has(departmentName)) {
        departmentMap.set(departmentName, departmentMap.get(departmentName) + ", " + vendorName);
      } else {
        departmentMap.set(departmentName, vendorName);
      }
    });

    const uniqueDepartmentsData = Array.from(departmentMap).map(([departmentName, vendors]) => {
      return {
        id: departmentName,
        userGroup: { name: departmentName },
        vendor: { name: vendors },
      };
    });

    return uniqueDepartmentsData;
  };
   $(".rdt_Table").attr("aria-label","Preferred Vendors"); 
   $(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
   })
   const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Preferred vendors', url:''},
  ];
  useEffect(()=>{
    $(".lastdisable").trigger("focus");
  }, [])

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
            <div className="project-setting-page">
              <div className="project-heading userprofile-heading">
                <div className="back-arrow flex-center">
                  <button
                    ref={backRef}
                    aria-label="back"
                    onClick={() => navigate("/settings")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                    >
                      <path
                        d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                        fill="#1D4ED8"
                      />
                    </svg>
                  </button>
                  <span>Back to Settings</span>
                </div>
                <h3 className="flex">
                  Preferred Vendors
                 </h3>
               <span>
                  Which vendors are specifically presented as an option for quote
                  requests.
                </span>
              </div>
              <div className="white-bg">
                
                <div className="datatable-block">
                    <DataTable
                      keyField="id"
                      columns={columns}
                      data={preferedVendorAllGroup}
                      responsive
                      striped
                      pointerOnHover={true}
                      progressPending={pending}
                      noDataComponent={noDataFoundComponent()}
                      onSort={handleSort}
                     // defaultSortFieldId="prefferedVendor.name"
                    />
                  </div>
                  {/* <table className="sortable">
                    <thead>
                      <th>Preferred Vendor</th>
                      <th>Department</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>ABC Translations</td>
                        <td>Anurag V Test Department</td>
                      </tr>
                      <tr>
                        <td>ABC Translations</td>
                        <td>Depart_2</td>
                      </tr>
                      <tr>
                        <td>AccuTrans</td>
                        <td>BDept</td>
                      </tr>
                      <tr>
                        <td>AccuTrans</td>
                        <td>Depart_1</td>
                      </tr>
                      <tr>
                        <td>AccuTrans</td>
                        <td>Department5-Renu</td>
                      </tr>
                    </tbody>
                  </table> */}
                
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
